import React from "react";
import OverridesShell from "../Shell/OverridesShell.jsx";
import FloatingSupportButton from "../../../components/FloatingSupportButton.jsx";

export default function AgentOverrides() {
	return <OverridesShell footerSlot={<FloatingSupportButton />} />;
}
